import { render, staticRenderFns } from "./simulator.vue?vue&type=template&id=19cd395a&lang=pug&"
import script from "./simulator.vue?vue&type=script&lang=js&"
export * from "./simulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19cd395a')) {
      api.createRecord('19cd395a', component.options)
    } else {
      api.reload('19cd395a', component.options)
    }
    module.hot.accept("./simulator.vue?vue&type=template&id=19cd395a&lang=pug&", function () {
      api.rerender('19cd395a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/simulator.vue"
export default component.exports